
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/illustrations/subcategory/[slug]",
      function () {
        return require("private-next-pages/illustrations/subcategory/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/illustrations/subcategory/[slug]"])
      });
    }
  